import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { LeadSourceService } from 'src/app/services/lead-source.service';

@Component({
  selector: 'calsoft-xlmapper-dialog',
  templateUrl: './xlmapper-dialog.component.html',
  styleUrls: ['./xlmapper-dialog.component.scss']
})
export class XlmapperDialogComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';


  data: any;
  text: string;

  selectedTitle: string | null = null;

  firstFormGroup: UntypedFormGroup;

  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<XlmapperDialogComponent>,
    private _formBuilder: UntypedFormBuilder,
    private leadSourceService: LeadSourceService, private router: Router

  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });

    this.data = data;
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });
  }


  ngOnInit() {

    this.text = 'Submit';

    this.initForm();

    this.getAllAttributeList();
    
    this.attributeYFilter();
   
  }

  initForm() {
      this.firstFormGroup = this._formBuilder.group({
        id: [0],
        name:[''],
        sourceMapper: this._formBuilder.array([
          this.initSourceMapper()
        ]),
  
      });
    }
  
    initSourceMapper(): UntypedFormGroup {
      return this._formBuilder.group({
        sourceMapperId: [''],
        sourceId: [''],
        formFields: [''],
        fieldMapper: [''],
        type: [0],
        isActive: [0],
      });
    }

    addOption() {
  
      (<UntypedFormArray>this.firstFormGroup.get('sourceMapper')).push(
        this.initSourceMapper()
      );

    }

    removeOption(i) {
      (<UntypedFormArray>this.firstFormGroup.get('sourceMapper')).removeAt(i);
    }


  close() {
    this.dialogRef.close({ event: 'close' })
  }

  submit() {
    if (this.firstFormGroup.valid) {
      this.text = 'Processing';
  
      setTimeout(() => {
        const formData = this.firstFormGroup.value;
  
        console.log('🔗 Mapped Fields Table:');
        console.table(
          formData.sourceMapper.map((item, index) => ({
            'No': index + 1,
            'Mapped Field': item.fieldMapper,
            'Form Field': item.formFields
          }))
        );
  
        this.dialogRef.close({
          event: 'submit',
          data: formData
        });
  
        this.text = 'Submit';
      }, 500);
  
    } else {
      this.firstFormGroup.markAllAsTouched();
    }
  }
  


  //attribute
    attributeList: any = [];
    attributeTypeList: any = [];
    filteredAttributeTypeList: any = [];
    attributeControl: UntypedFormControl = new UntypedFormControl();
    attributeFilterControl: UntypedFormControl = new UntypedFormControl();

      protected _onDestroy = new Subject<void>();
  
    getAllAttributeList() {
  
      this.leadSourceService.getDropDown(9).subscribe(
        data => {
          this.attributeList = data;
  
  
          // this.attributeList.push(object);
  
          this.attributeTypeList = data;
          this.filteredAttributeTypeList = this.attributeTypeList;
  
        }
      )
  
      this.attributeYFilter();
   
    }
  
  
    getAllAttribute() {
      this.filteredAttributeTypeList = this.attributeTypeList;
    }
  
    attributeYFilter() {
      this.attributeFilterControl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.attributeFilter();
        });
    }
  
    protected attributeFilter() {
      if (!this.attributeList) {
        return;
      }
      // get the search keyword
      let search = this.attributeFilterControl.value;
      if (!search) {
        this.filteredAttributeTypeList = this.attributeTypeList.slice();
        return;
      } else {
        search = search.toLowerCase();
      }
      // filter the banks
      this.filteredAttributeTypeList = this.attributeTypeList.filter(Attribute => Attribute['frontendLabel'].toLowerCase().indexOf(search) > -1)
    }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  isFieldAlreadySelected(attributeCode: string, currentIndex: number): boolean {
    const sourceMapper = this.firstFormGroup.get('sourceMapper').value;

    return sourceMapper.some((group, index) => {
      return index !== currentIndex && group.formFields === attributeCode;
    });
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
